/** A sick leave's doctor's documents, as legacy took them: at most 5 files, 10 MB together, images, PDF
 * or zip. LEAVE_REQUEST_SUBMIT takes at most 5 file ids too. */
export const MAX_LEAVE_DOCUMENTS = 5;
export const MAX_LEAVE_DOCUMENTS_BYTES = 10 * 1024 * 1024;
export const LEAVE_DOCUMENT_ACCEPT = 'image/*,.pdf,.zip';

const isAllowedType = (file: File) =>
  file.type.startsWith('image/') || /\.(pdf|zip)$/i.test(file.name);

/** `current` with `added` appended, or the translation key of why they can't be added. */
export const addLeaveDocuments = (
  current: File[],
  added: File[]
): { files: File[]; error?: undefined } | { files?: undefined; error: string } => {
  if (added.some((file) => !isAllowedType(file)))
    return { error: 'SICK_LEAVE_FILE_TYPE_NOT_ALLOWED' };
  const files = [...current, ...added];
  if (files.length > MAX_LEAVE_DOCUMENTS) return { error: 'SICK_LEAVE_TOO_MANY_FILES' };
  if (files.reduce((total, file) => total + file.size, 0) > MAX_LEAVE_DOCUMENTS_BYTES)
    return { error: 'SICK_LEAVE_FILES_TOO_LARGE' };
  return { files };
};
